import { GameType } from '../../../models/communication/app-enums.model';
import { OpenGameFlow } from '../../game-flows/open.game.flow';
import { BaccaratGame } from '../baccarat/baccarat.game';

export class OpenBaccaratGame extends BaccaratGame {
    override gameType = GameType.OpenBaccarat;
    override flow: OpenGameFlow = new OpenGameFlow(this);
}
